import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    McpRealtimeService,
    McpRealtimeStatus,
    McpTranscriptEntry,
} from '../mcp-realtime.service';
import { RealtimeSegment } from './realtime-segment.types';

@Injectable({ providedIn: 'root' })
export class OpenAiRealtimeSegment implements RealtimeSegment {
    readonly id = 'openai' as const;

    constructor(private readonly realtime: McpRealtimeService) {}

    get status$(): Observable<McpRealtimeStatus> {
        return this.realtime.status$;
    }

    get transcript$(): Observable<McpTranscriptEntry[]> {
        return this.realtime.transcript$;
    }

    get aiSpeaking$(): Observable<boolean> {
        return this.realtime.aiSpeaking$;
    }

    get micMuted$(): Observable<boolean> {
        return this.realtime.micMuted$;
    }

    start(): Promise<void> {
        return this.realtime.start();
    }

    prewarm(): Promise<void> {
        return this.realtime.prewarm();
    }

    stop(): void {
        this.realtime.stop();
    }

    setMicMuted(muted: boolean): void {
        this.realtime.setMicMuted(muted);
    }

    toggleMic(): void {
        this.realtime.toggleMic();
    }

    sendText(text: string): void {
        this.realtime.sendText(text);
    }
}
